import { Component, computed, inject, input } from '@angular/core';
import { IconNameType } from '../icons/icon-name-type.enum';
import { AccentButtonComponent } from '../accent-button/accent-button.component';
import { AccentButtonStyleType } from '../accent-button/button-types.enum';
import { DottedLabelsComponent } from '../dotted-labels/dotted-labels.component';
import { IconLabelValueComponent } from '../icon-label-value/icon-label-value.component';
import { OrderService } from '../../core/services/order.service';
import { IconUtils } from '../../core/utils/icon-utils';
import { DateTime } from 'luxon';
import { TranslocoDirective, TranslocoService } from '@ngneat/transloco';
import { ModalService, ModalName } from '../../core/services/modal.service';
import { IconComponent } from '../icons/icon.component';
import { StoreConfig } from '../../core/models/core/store-config.model';
import { AuditService } from '../../core/services/audit.service';
@Component({
  selector: 'cwo-order-details-information',
  standalone: true,
  templateUrl: './order-details-information.component.html',
  styleUrl: './order-details-information.component.scss',
  imports: [
    AccentButtonComponent,
    DottedLabelsComponent,
    IconLabelValueComponent,
    TranslocoDirective,
    IconComponent
  ],
})
export class OrderDetailsInformationComponent {
  iconNameType = IconNameType;
  modalService = inject(ModalService);
  orderService = inject(OrderService);
  store = input<StoreConfig>();
  orderType = input.required<string>();
  address = input<string>();
  addressName = input<string>();
  schedule = input<string>();
  deferDate = input<DateTime>();
  isInCheckout = input(false);
  parentExpanded = input<boolean>(true);
  transloco = inject(TranslocoService);
  auditService = inject(AuditService);

  accentButtonStyleType = AccentButtonStyleType;

  // the same can be found in mobile-nav-menu.component.ts
  // extract the logic to a shared function
  formattedDateLabel = computed(() => {
    if(this.schedule() === 'ASAP'){
      const asapLabel = this.orderService.activeOrderType()?.asapLabel;
      return asapLabel ? asapLabel : this.transloco.translate('shared_components.order_details_information.asap');
    } else if(this.schedule() === 'Today'){
      return this.transloco.translate('shared_components.order_details_information.today');
    }  else if(this.schedule() === 'None'){
      return 'None';
    } else {
      const currentDate = DateTime.local();
      const tomorrow = currentDate.plus({ days: 1 });
      const isTomorrow = this.deferDate()?.hasSame(tomorrow, 'day');

      return isTomorrow
        ? this.transloco.translate('shared_components.order_details_information.tomorrow')
        : this.deferDate()?.toFormat('MM/dd/yyyy');
    }
  });

  scheduleInfoLabels = computed(() => {
    const labels = [];
    if(this.formattedDateLabel()){
      labels.push(this.formattedDateLabel()!);
    }
    if(this.deferDate()){
      labels.push(this.deferDate()!.toFormat('hh:mm a'));
    }

    return labels;
  })


  handleChangeOrderDetails() {
    this.auditService.createAudit(() =>'Change button clicked on Order Details modal');
    this.modalService.updateModalState(ModalName.OrderDetails, {
      showOrderEditor: !this.modalService.stateForModal(ModalName.OrderDetails).showOrderEditor
    });
  }

  handleEditStore() {
    this.auditService.createAudit(() =>'Change Store button clicked');
    this.modalService.updateModalState(ModalName.OrderDetails, {
      showOrderEditor: false, 
      showStoreChooser: true,
    });
  }

  handleDone() {
    this.modalService.closeModal();
  }

  calcAddressIcon(): IconNameType {
    return IconUtils.calcAddressIcon(this.orderService.order().customer?.address?.addressType)
  }

  addressLabel() {
    if (this.orderService.order().customer?.customerId !== 0 && this.orderService.order().customer?.address?.name) {
      return this.orderService.order().customer?.address?.name?.toUpperCase() ?? '';
    } else {
      return this.transloco.translate('shared_components.order_details_information.my_address');
    }
  }
}
